import React from "react";

// styles
import useStyles from "./styles";

// components
import {Typography} from "../Wrappers/Wrappers";
import {Grid} from "@material-ui/core";


function PageTitle(props) {
    const classes = useStyles();

    return (
        <div className={classes.pageTitleContainer}>
            <Grid container justify="space-between"
                                alignItems="center">
                <Grid item xs={12} md={9}>
                    <Typography className={classes.typo} variant="h1" size="sm">
                        {props.title}
                        {props.chip}
                    </Typography>

                </Grid>
                <Grid item xs={12} md={3} className={classes.buttonTitleContainer}>
                    {props.button && props.button}
                </Grid>
            </Grid>
        </div>
    );
}


export default PageTitle